import fetch from '@/helpers/fetch';

export default {
	state: {
	},
	mutations: {
	},
	actions: {
		startChallenge: async function (context, data): Promise<object | void> {
			return await fetch.post('/api/challenge/start', { email: data.email, url: data.url })
		},
	},
}
